import React, { useEffect, useState } from 'react';

import { usePlatformConfig } from 'contexts/PlatformConfigContext';

import {
  feetToMeters,
  kilometersToMiles,
  metersToFeet,
  milesToKilometers
} from 'utils/functions/distanceConversion';

import { Text } from 'components/DataDisplay';
import { Radio, Select, TextField } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

export const RadiusCustomization = ({
  params,
  setParams,
  color = null,
  bgColor = null
}) => {
  const { name: platformLocation } = usePlatformConfig();
  const [otherRange, setOtherRange] = useState(false);

  const [displayParams, setDisplayParams] = useState(() => {
    if (platformLocation === 'US') {
      return {
        distance:
          params.unit === 'm'
            ? metersToFeet(params.distance)
            : kilometersToMiles(params.distance),
        unit: params.unit === 'm' ? 'ft' : 'mi'
      };
    }
    return { ...params };
  });

  const unitOptions =
    platformLocation === 'US'
      ? [
          { label: 'miles', value: 'mi' },
          { label: 'feet', value: 'ft' }
        ]
      : [
          { label: 'metre', value: 'm' },
          { label: 'kilometre', value: 'km' }
        ];

  const handleDisplayParamsChange = updatedDisplayParams => {
    setDisplayParams(updatedDisplayParams);

    if (platformLocation === 'US') {
      const convertedDistance =
        updatedDisplayParams.unit === 'ft'
          ? feetToMeters(updatedDisplayParams.distance)
          : milesToKilometers(updatedDisplayParams.distance);
      const convertedUnit = updatedDisplayParams.unit === 'ft' ? 'm' : 'km';
      setParams({
        ...params,
        distance: convertedDistance,
        unit: convertedUnit
      });
    } else {
      setParams({ ...params, ...updatedDisplayParams });
    }
  };
  const verifyInitialRay = values => {
    // eslint-disable-next-line no-param-reassign
    values.distance += '';
    if (values.unit === 'm') {
      if (
        values.distance !== 20000 &&
        values.distance !== 30000 &&
        values.distance !== 50000
      ) {
        return true;
      }
    } else if (
      values.unit === 'km' &&
      values.distance !== '20' &&
      values.distance !== '20.00' &&
      values.distance !== '30' &&
      values.distance !== '30.00' &&
      values.distance !== '50' &&
      values.distance !== '50.00'
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (
      params.unit !== displayParams.unit &&
      params.distance !== displayParams.distance
    ) {
      setDisplayParams(() => {
        if (platformLocation === 'US') {
          return {
            distance:
              params.unit === 'm'
                ? metersToFeet(params.distance)
                : kilometersToMiles(params.distance),
            unit: params.unit === 'm' ? 'ft' : 'mi'
          };
        }
        return { ...params };
      });
    }
    setOtherRange(verifyInitialRay(params));
    // eslint-disable-next-line
  }, [params]);

  return (
    <Container>
      <Row justify="flex-start" alignItems="flex-end" spacing={1}>
        <Item xs={otherRange ? 6 : 12}>
          {['20', '30', '50'].map(value => {
            return (
              <Item flex style={{ alignItems: 'center' }}>
                <Radio
                  checked={
                    parseFloat(displayParams.distance).toFixed(2) ===
                      parseFloat(value).toFixed(2) &&
                    displayParams.unit === unitOptions[1].value
                  }
                  onChange={() => {
                    if (otherRange) {
                      setOtherRange(false);
                    }
                    handleDisplayParamsChange({
                      ...displayParams,
                      distance: parseFloat(value).toFixed(2),
                      unit: unitOptions[1].value
                    });
                  }}
                />
                <Text>
                  {value}
                  {unitOptions[1].value}
                </Text>
              </Item>
            );
          })}
          <Item flex style={{ alignItems: 'center' }}>
            <Radio
              checked={otherRange}
              onChange={() => {
                setOtherRange(true);
                handleDisplayParamsChange({
                  ...displayParams,
                  distance: 500,
                  unit: unitOptions[0].value
                });
              }}
            />
            <Text>Autres</Text>
          </Item>
        </Item>
        {otherRange && (
          <>
            <Item xs={3}>
              <TextField
                small
                title="distance"
                bgColor={bgColor}
                color={color}
                value={displayParams.distance}
                type="number"
                onChange={e =>
                  handleDisplayParamsChange({
                    ...displayParams,
                    distance: parseFloat(e).toFixed(2)
                  })
                }
              />
            </Item>
            <Item xs={3} justify="flex-start">
              <Select
                small
                title="Unité"
                bgColor={bgColor}
                color={color}
                value={displayParams.unit}
                options={unitOptions}
                onChange={change => {
                  handleDisplayParamsChange({
                    ...displayParams,
                    unit: change
                  });
                }}
              />
            </Item>
          </>
        )}
      </Row>
    </Container>
  );
};

export default RadiusCustomization;
